"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PimMapper = void 0;
const helpers_1 = require("../../../helpers");
const formatters_1 = require("../../../formatters");
const constants_1 = require("../../../../constants");
class PimMapper {
    static getResidualValueFieldsFromVehicleConfig(vehicleConfig) {
        return (vehicleConfig === null || vehicleConfig === void 0 ? void 0 : vehicleConfig.pricing)
            ? Object.keys(vehicleConfig.pricing)
                .filter((key) => key.startsWith(this.residualValuePrefix))
                .reduce((fields, key) => (Object.assign(Object.assign({}, fields), { [key]: vehicleConfig.pricing[key] })), {})
            : null;
    }
    static getResidualValuesData(key, residualValue) {
        const isExVAT = key.indexOf(this.residualValueSuffix) > -1;
        const dataString = key.replace(this.residualValuePrefix, '').replace(this.residualValueSuffix, '').replace('k', '');
        const [durationData, rangeData] = dataString.split('y').map((item) => parseInt(item));
        const range = (rangeData * 1000) / durationData;
        const duration = durationData * 12;
        return Object.assign({ range,
            duration }, (isExVAT ? { residualValueExVAT: residualValue } : { residualValue }));
    }
    static getResidualValueList(vehicleConfig) {
        if (!vehicleConfig)
            return [];
        const fields = this.getResidualValueFieldsFromVehicleConfig(vehicleConfig);
        return !!fields
            ? Object.keys(fields)
                .map((key) => this.getResidualValuesData(key, fields[key]))
                .reduce((acc, field) => {
                const itemIndex = acc.findIndex((item) => item.duration === field.duration && item.range === field.range);
                if (itemIndex > -1) {
                    const mergeItem = Object.assign(Object.assign({}, acc.splice(itemIndex, 1)[0]), field);
                    return [...acc, mergeItem];
                }
                return [...acc, field];
            }, [])
            : [];
    }
    static getResidualValue(vehicleConfig, duration, range, isExVAT = false) {
        if (!vehicleConfig)
            return null;
        const list = this.getResidualValueList(vehicleConfig);
        const foundItem = list.find((item) => item.duration === duration && item.range === range);
        if (!foundItem)
            return null;
        return isExVAT ? Math.round(foundItem.residualValueExVAT) : Math.round(foundItem.residualValue);
    }
    static getLeasingRangeDropdownOptionsByDuration(vehicleConfig, duration = null) {
        const list = this.getResidualValueList(vehicleConfig);
        const filteredList = typeof duration === 'number'
            ? list.filter((item) => (typeof duration === 'number' ? item.duration === duration : true))
            : list;
        return (0, helpers_1.getUniqueItemsByKey)(filteredList, 'range').map((item) => ({
            isSelected: item.range === constants_1.defaultLeasingInput.mileage,
            label: `${(0, formatters_1.formatNumber)(item.range, 0)} km`,
            value: item.range,
        }));
    }
    static getLeasingDurationDropdownOptionsByRange(vehicleConfig, range = null) {
        const list = this.getResidualValueList(vehicleConfig);
        const filteredList = typeof range === 'number'
            ? list.filter((item) => (typeof range === 'number' ? item.range === range : true))
            : list;
        return (0, helpers_1.getUniqueItemsByKey)(filteredList, 'duration').map((item) => ({
            isSelected: item.duration === constants_1.defaultLeasingInput.durationMonths,
            label: `${item.duration} mnd`,
            value: item.duration,
        }));
    }
    static getLeasingDropdownOptions(vehicleConfig) {
        return {
            duration: this.getLeasingDurationDropdownOptionsByRange(vehicleConfig),
            range: this.getLeasingRangeDropdownOptionsByDuration(vehicleConfig),
        };
    }
}
exports.PimMapper = PimMapper;
PimMapper.residualValuePrefix = 'residualValue';
PimMapper.residualValueSuffix = 'ExcludingVat';
//# sourceMappingURL=pim.js.map